















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *
 *  Component to render a summary: items that are divided by
 *  a vertical, skewed divider line.
 *
 *  (i) The items should be provided as `SummaryItems` components
 *
 */
@Component
export default class Summary extends Vue {

    @Prop({ type: Boolean })
    private small!: boolean;

}
